<script>
import AppointmentRequest from './appointment-request.vue'
import Toast from '../lib/toast.vue'
export default {
  components: { AppointmentRequest, Toast },
  props: {
    contactId: {type: String, required: true},
    // Compact mode (e.g. recommendation cards): show only the message button
    // in the connected state, hiding the appointment-request action.
    compact: {type: Boolean, default: false},
  },

  data() {
    return {
      observed: this.$storage.observed,
      userUuid: this.$storage.getUserUuid(),
      directChannel: this.$storage.getDirectChannel(this.contactId),
      displayAppRequestForm: false,
      showConnectForm: false,
      introMessage: '',
      toastMessage: '',
    }
  },

  computed: {
    // A pending outgoing request appears as connection_state 'outgoing'.
    isPendingOutgoing() {
      return this.directChannel && this.directChannel.connection_state === 'outgoing'
    },
    // Connected = an accepted direct channel exists (legacy channels report 'accepted').
    isConnected() {
      return this.directChannel && this.directChannel.connection_state !== 'outgoing'
    },
  },

  watch: {
    'observed.directChannels': function () {
      let me = this
      setTimeout(function() {
        me.directChannel = me.$storage.getDirectChannel(me.contactId)
      }, 500);
    }
  },

  methods: {
    routeToPrivateChannel(channel, params={}) {
      this.$router.push({path: `/community/${this.contactId}/${channel.id}`, query: params})
    },

    onConnectClick() {
      // Compact (recommendation cards): one-tap connect, no inline intro form
      // -- keeps the right-aligned button tidy. The full contact view still
      // offers the optional intro message.
      if (this.compact)
        this.sendConnectionRequest()
      else
        this.showConnectForm = true
    },

    sendConnectionRequest() {
      let me = this
      this.$chat.post('channels/direct/', {
        user_uuid: this.contactId,
        intro_message: this.introMessage,
      }).then(function(response) {
        me.directChannel = response.data
        me.showConnectForm = false
        me.introMessage = ''
        me.$storage.fetchContactsForUser()
        // Crossed request -> already connected: open the chat. Otherwise the
        // recipient must accept first (stay on "Anfrage gesendet").
        if (response.data.connection_state === 'accepted')
          me.routeToPrivateChannel(response.data)
      }).catch(function(error){
        // e.g. blocked contact: backend answers 403 with a neutral message
        let data = error.response && error.response.data
        me.toastMessage = (data && data.error) || 'Verbindung nicht möglich.'
        me.showConnectForm = false
      })
    },

    onPrivateMessage(data) {
      // Only reachable for connected contacts (button hidden otherwise).
      if (this.directChannel)
        this.routeToPrivateChannel(this.directChannel, data)
    },

    getEndTime(startTime, mins) {
      let date = new Date()
      const [hh, mm] = startTime.split(':').map(Number)
      date.setUTCHours(hh, mm + mins, 0, 0)
      return date.toISOString().slice(11,16)
    },

    onAppointmentRequest(info) {
      this.displayAppRequestForm = false
      let endTime = this.getEndTime(info.time, info.duration)
      let message = `:calendar: Terminanfrage: **${info.date}** ${info.time}–${endTime} Uhr — ${info.subject}`
      this.onPrivateMessage({
        message: message,
        meeting_date: info.date,
        meeting_time: info.time,
        meeting_end: endTime,
        meeting_subject: info.subject,
      })
    }
  },
}
</script>

<template>
  <div>
    <!-- Connected: normal messaging -->
    <template v-if="isConnected">
      <button @click.prevent="onPrivateMessage" class="btn btn-secondary" :class="{ 'btn-sm': compact }">
        Nachrichten&nbsp;<span v-if="directChannel && directChannel.numUnreadMessages" class="badge bg-danger">{{ directChannel.numUnreadMessages }}</span>
      </button>
      <button v-if="!compact" @click.prevent="displayAppRequestForm = !displayAppRequestForm"
       class="btn btn-secondary ms-1">
        Termin-Anfrage
      </button>
      <appointment-request v-if="displayAppRequestForm"
       @submit="onAppointmentRequest($event)"
       @cancel="displayAppRequestForm = false"
       class="mt-3"
      />
    </template>

    <!-- Pending outgoing request -->
    <button v-else-if="isPendingOutgoing" class="btn btn-outline-secondary" :class="{ 'btn-sm': compact }" disabled>
      <i class="fas fa-clock"></i> Anfrage gesendet
    </button>

    <!-- Not connected yet: connection request -->
    <template v-else>
      <button v-if="!showConnectForm" @click.prevent="onConnectClick" class="btn btn-primary" :class="{ 'btn-sm': compact }">
        <i class="fas fa-user-plus"></i> Verbinden
      </button>
      <div v-else class="mt-1">
        <textarea v-model="introMessage" class="form-control mb-2" rows="2"
         placeholder="Nachricht (optional)"></textarea>
        <button @click.prevent="sendConnectionRequest" class="btn btn-primary btn-sm">
          Anfrage senden
        </button>
        <button @click.prevent="showConnectForm = false" class="btn btn-outline-secondary btn-sm ms-1">
          Abbrechen
        </button>
      </div>
    </template>

    <toast v-if="toastMessage" :message="toastMessage" type="error" @closed="toastMessage = ''" />
  </div>
</template>
